jQuery(document).ready(function($) {
  if (!$('.tabs-with-content').length) {
    return;
  }

  // Desktop
  $('.tabs-with-content-main .tabs-with-content-tab-title').click(function() {
    // Get content
    var tab = $(this).parent(),
      title = tab.find('.tabs-with-content-tab-title').html(),
      subtitle = tab.find('.tabs-with-content-tab-subtitle').html(),
      content = tab.find('.tabs-with-content-content-hidden').html();

    // Replace content
    var active_content = $('.tabs-with-content-content'),
      active_title = $('.tabs-with-content-active-title'),
      active_subtitle = $('.tabs-with-content-active-subtitle');

    // Get tab image
    const tabImage = tab.data('bg-image');

    // Animation
    $(active_content)
      .add(this)
      .add(active_title)
      .add(active_subtitle)
      .stop()
      .animate(
        {
          opacity: 0,
        },
        500,
        function() {
          active_content.html(content);
          active_title.html(title);
          active_subtitle.html(subtitle);

          // Change tabs on the left
          $('.tabs-with-content-tab').removeClass('hidden');
          tab.addClass('hidden');

          $(active_content)
            .add(this)
            .add(active_title)
            .add(active_subtitle)
            .stop()
            .animate(
              {
                opacity: 1,
              },
              500
            );

          if (tabImage.length > 0) {
            active_content.css({
              backgroundImage: `url(${tabImage})`,
            });
          }
        }
      );
  });

  // Mobile
  $('.tabs-with-content-tab-close').click(function() {
    $('.tabs-with-content-content-mobile').hide();
    $('.tabs-with-content-tab-close').show();
    $(this).hide();
    $(this).prev().show();
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/tabs-with-content.js